var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-shop-tab"},[_c('div',{staticClass:"ivu-tabs-tab ivu-tabs-tab-active"},[_vm._v(" "+_vm._s(_vm.shopName)+" "),_c('i-badge',{attrs:{"count":_vm.badgeCount}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }